import './text-image.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTextImage = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.text-image__section'), (el) => {
    window.dAgency.initTextImage(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.text-image__section'), (el) => {
      window.dAgency.initTextImage(el);
    });
  });
}
